import DataQuery from 'data/DataQuery';
import { Customer_Get } from 'data/endpoints';
import IRequirementCreateService from 'features/requirements/services/IRequirementCreateService';
import PageCard from 'features/shared/components/card/PageCard';
import FormGroup from 'features/shared/forms/components/FormGroup';
import { useForm } from 'features/shared/forms/hooks/useForm';
import { getRouteParams } from 'features/shared/helpers/routeParams';
import { useInjection } from 'infrastructure/ioc/ioc.react';
import { IocTypes } from 'infrastructure/ioc/ioc.types';
import CustomerState from 'infrastructure/store/customer/CustomerState';
import IAppState from 'infrastructure/store/IAppState';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import BasicInfoSubFormSection from '../basicInfoSubForm/BasicInfoSubFormSection';
import { useQuery } from 'data/hooks/useQuery';
import CustomerDTO from 'features/customer/dtos/CustomerDTO';
import AddressAutocomplete from 'features/shared/components/addressAutocomplete/AddressAutocomplete';
import { Nullable } from 'features/shared/types/nullable';
import AddressFindEnumDTO from 'features/shared/enums/dynamic/AddressFindEnumDTO';
import AddressBox from 'features/requirements/components/addressForm/AddressBox';
import IAddressFormService from 'features/requirements/services/IAddressFormService';
import { addressFormValidations } from './addressFormValidation'
import { useTranslation } from 'react-i18next';
import { openRequirementResultDialog } from 'features/requirements/helpers/requirementResultDialogHelper';

const AddressFormSection = () => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  // DI
  const createService = useInjection<IRequirementCreateService>(IocTypes.RequirementCreateService);
  const formService = useInjection<IAddressFormService>(IocTypes.AddressFormService);

  // store
  const customerState = (useSelector<IAppState, CustomerState>((store) => store.customer)).customer;

  // fetch data
  let query: DataQuery = {url: Customer_Get, routeParams: getRouteParams("customerId", customerState.customerId!)};
  const { data: customer } = useQuery<CustomerDTO>(query, {}, [customerState]);

  // state
  const [selectedAddress, setSelectedAddress] = useState<Nullable<AddressFindEnumDTO>>(null);

  // form hook
  const { values, setFormValue, errors, bindField, bindUncontrolledField, valideteForm, setValidationRule, validateFormField } = useForm({
    initialValidations: addressFormValidations()
  });

  // handlers
  const submitFormHandler = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (valideteForm()) {
      let originalAddress = formService.getOriginalAddressValues(customer.address!);
      let newAddress = formService.getNewAddressValues(selectedAddress!);
      let formValues = {...originalAddress, ...newAddress, ...values};

      let result = await createService.createRequirement("ZMENATRVALEADRESY_SIDLASPOLECNOSTI", formValues);
      openRequirementResultDialog(false, { response: result });
    }
  };

  const addressChangeHandler = (address: Nullable<AddressFindEnumDTO>) => {
    validateFormField("Address", address);
    setFormValue("Address", address); // setting address is necessary for correct validation
    setSelectedAddress(address);
  }

  // render
  return (
    <form onSubmit={submitFormHandler}>
      <PageCard title={tLabels("addressFormSection.cardTitle")} bodyClassName="pt-4 px-4 pb-0">
        <FormGroup labelText={tLabels("addressFormSection.newAddress")} validationError={errors["Address"]}>
          <AddressAutocomplete onChange={addressChangeHandler} />
        </FormGroup>
        <div className="row no-gutters mt-4">
          <div className="col-sm-auto pr-sm-4 mb-4">
            <AddressBox title={tLabels("addressFormSection.newAddress")} address={selectedAddress} />
          </div>
          <div className="col-sm-auto mb-4">
            <AddressBox title={tLabels("addressFormSection.currentAddress")} address={customer.address!} />
          </div>
        </div>
      </PageCard>

      <BasicInfoSubFormSection
        bindField={bindField}
        bindUncontrolledField={bindUncontrolledField}
        errors={errors}
        setValidationRule={setValidationRule}
      />

      <button type="submit" className="btn btn-primary px-3 py-2">{tLabels("addressFormSection.sendRequirement")}</button>
    </form>
  )
}

export default AddressFormSection;
